/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_MitgliedschaftInputs */

const de__field_mitgliedschaft = /** @type {(inputs: _Field_MitgliedschaftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitgliedschaft`)
};

/**

* @param {_Field_MitgliedschaftInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_mitgliedschaft = /** @type {((inputs?: _Field_MitgliedschaftInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_MitgliedschaftInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_mitgliedschaft(inputs)
});